import React from "react";
import {
	CaloAILinkContainer,
	FoodLensLinkContainer,
	GithubLinkContainer,
	GithubLinkContents,
	GithubLinkTitle,
	GuideLinkButton,
	/* LinkSectionBodyDescriptionContent,
	LinkSectionBodyDescriptionTitle,
	LinkSectionBodyDescriptionWrapper,
	LinkSectionBodyWrapper,
	LinkSectionHeader, */
	LinkSectionWrapper,
} from "@/views/Application/Dashboard/LinkSection/style";
import ic_github from "@/assets/ic_github.svg";

interface LinkSectionProps {
	translationObject: any;
}

const LinkSection: React.FC<LinkSectionProps> = ({ translationObject }) => {
	return (
		<>
			<LinkSectionWrapper>
				<GithubLinkContainer>
					<FoodLensLinkContainer>
						<GithubLinkTitle>
							<img
								src={ic_github}
								alt="github icon"
								style={{ marginRight: "10px" }}
							/>
							<div style={{ alignSelf: "center" }}>
								{translationObject("github_link_title_foodlens")}
							</div>
						</GithubLinkTitle>
						<GithubLinkContents>
							{translationObject("github_link_contents_foodlens")}
						</GithubLinkContents>
						<GuideLinkButton
							variant="outlined"
							onClick={() => {
								window.open(
									"https://github.com/doinglab/FoodLensSDK/tree/master/Android",
								);
							}}
						>
							Android
						</GuideLinkButton>
						<GuideLinkButton
							variant="outlined"
							onClick={() => {
								window.open(
									"https://github.com/doinglab/FoodLensSDK/tree/master/IOS",
								);
							}}
						>
							iOS
						</GuideLinkButton>
					</FoodLensLinkContainer>
					<CaloAILinkContainer>
						<GithubLinkTitle>
							<img
								src={ic_github}
								alt="github icon"
								style={{ marginRight: "10px" }}
							/>
							<div style={{ alignSelf: "center" }}>
								{translationObject("github_link_title_caloai")}
							</div>
						</GithubLinkTitle>
						<GithubLinkContents>
							{translationObject("github_link_contents_caloai")}
						</GithubLinkContents>
						<GuideLinkButton
							variant="outlined"
							onClick={() => {
								window.open(
									"https://github.com/doinglab/CaloAISDK/tree/main/Android",
								);
							}}
						>
							Android
						</GuideLinkButton>
						<GuideLinkButton
							variant="outlined"
							onClick={() => {
								window.open(
									"https://github.com/doinglab/CaloAISDK/tree/main/IOS",
								);
							}}
						>
							iOS
						</GuideLinkButton>
					</CaloAILinkContainer>
				</GithubLinkContainer>
			</LinkSectionWrapper>
			{/* <LinkSectionWrapper>
			<LinkSectionHeader>빠르게 Foodlens 사용하기</LinkSectionHeader>
			<LinkSectionBodyWrapper>
				<LinkSectionBodyDescriptionWrapper>
					<LinkSectionBodyDescriptionTitle>
						Foodlens 깃허브
					</LinkSectionBodyDescriptionTitle>
					<LinkSectionBodyDescriptionContent>
						Foodlens를 빠르게 사용할 수 있는 깃허브 문서입니다.
					</LinkSectionBodyDescriptionContent>
				</LinkSectionBodyDescriptionWrapper>
				<div>
					<a
						href="https://github.com/doinglab/FoodLensSDK/tree/master/Android"
						target="blank"
					>
						<Button
							variant="outlined"
							style={{
								width: "7rem",
								height: "2.5rem",
								cursor: "pointer",
								borderColor: "#7E7E7E",
								color: "#404040",
								fontWeight: "bold",
								backgroundColor: "white",
								fontSize: "0.8rem",
								textTransform: "none",
							}}
						>
							Android
						</Button>{" "}
					</a>
					<a
						href="https://github.com/doinglab/FoodLensSDK/tree/master/IOS"
						target="blank"
					>
						<Button
							variant="outlined"
							style={{
								width: "7rem",
								height: "2.5rem",
								cursor: "pointer",
								borderColor: "#7E7E7E",
								color: "#404040",
								fontWeight: "bold",
								backgroundColor: "white",
								fontSize: "0.8rem",
								textTransform: "none",
							}}
						>
							iOS
						</Button>
					</a>
				</div>
			</LinkSectionBodyWrapper>
		</LinkSectionWrapper> */}
		</>
	);
};

export default LinkSection;
